
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { PostData } from '../Functions/SendingData';
import { Loading } from '../Loading';
import Price from '../Scomp/Price';
import Stars from "../Scomp/Stars";

const Styles = styled.div`
    /* .background-touch{
        z-index: 650;
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background-color: #00000055;
        opacity: 0;
        display: none;
        &.active {
            opacity:1;
            display: block;
        }
        &.deactive {
            opacity: 0;
            display: none;
        }
    } */
    position: fixed;
    inset: -13.2rem 32% auto auto;
    z-index: 997;
    overflow-y: auto;
    height: 50rem;
    /* display: flex;
    flex-direction:column; */
    .animation-detail {
        transition: all 0.3s ease-in-out;
    }
    .loading-anim {
        padding: 1rem;
        display: flex;
        justify-content: center;
    }
    .detail-down {
        z-index: 900;
        position: relative;
        direction: rtl;
        color: var(--text-2);
        border-radius: 0 0 var(--border-radius-2)  var(--border-radius-2);

        /* left: 0;
        right: 0; */
        width: 36vw;
        max-height: 30rem;
        /* top:105vh; */
        background-color: var(--body-2);
        padding: 0;
    
        
        &.active-down{
            animation: animation-to-active-down 0.5s ease-out 1 0s forwards !important;
        }
        &.deactive-down{
            animation: animation-center-deactive-down 0.3s ease-in 1 0s backwards !important;
        }

        @keyframes animation-to-active-down {
            100%  {
                    top: 35vh;
                }
        }
        @keyframes animation-center-deactive-down {
            0%  {
                    top: 35vh;
                }
        }
        .arrow-down{
            width: 2rem;
            fill: var(--primary-1);
            position: absolute;
            bottom: 1rem;
            right: calc(50% - 1rem);
            left: calc(50% - 1rem);
            svg{
                transform: rotate(90deg);
            }
        }

        .data-down{
            z-index: 950;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            overflow-x: hidden;
            margin: 1rem 2rem 2rem;
            direction: ltr;
            height: calc(100% - 3rem);
            padding: 1rem 0;
            ::-webkit-scrollbar-track {
                box-shadow: var(--shadow);
                background-color: #F5F5F555;
            }
            ::-webkit-scrollbar {
                width: 15px;
                background-color: #F5F5F500;
            }
            ::-webkit-scrollbar-thumb {
                background-color: #fff;
            }
            .loading-container{
                text-align: center;
                margin: 2rem auto;
                display: flex;
                justify-content: center;
            }
            .good-grid{
                direction: rtl;
                margin: 0.5rem 2rem 1rem;
                display: flex;
                flex-grow: 1;
                a {
                    text-decoration: none;
                    color: inherit;
                    width: 100%;
                    height: 100%;
                    max-height: 25rem;
                }
                .good{
                    box-shadow: var(--shadow);
                    background-color: var(--body-2);
                    border-radius: var(--border-radius);
                    width: calc(100% - 1rem);
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    padding: 0 0.5rem;
                    .image{
                        width: 60%;
                        padding-top: 60%;
                        position: relative;
                        background-color: var(--body-2);
                        border-radius: var(--border-radius);
                        overflow: hidden;
                        margin: 0 auto;

                        img {
                            width: 100% ;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            left: 0;
                            object-fit: contain;
                            transition: all 0.3s ease-in-out;
                            :hover{
                                transform: scale(1.05);
                            }
                        }
                    }
                    .detail {
                        margin: 0 1rem 0.5rem;
                        color: var(--text-2);
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                        .nameG {
                            flex-grow: 1;
                            padding: 0 0.3rem 0.8rem;
                            border-bottom: var(--stroke) solid var(--text-2);
                            display: flex;
                            flex-direction:column;
                            align-items: center;
                            display: flex;
                        .name{
                            font-size: var(--fs-search-name);
                            font-weight: 850;
                            text-align: center;
                            flex-grow: 1;
                            display: flex;
                        }
                        .brand{
                            font-size: var(--fs-search-price);
                            font-weight: 300;
                            flex-grow: 1;
                            display: flex;
                        }
                        .shop , .star{
                            flex-grow: 1;
                            display: flex;
                        }
                    }
                        
                    .curency{
                        font-size: var(--fs-search-price-text);
                        justify-content: center;
                        span{
                            font-size:var(--fs-search-price);
                            font-weight: bold;
                        }
                    }
                        
                    }
                }
            }

        }
    }
    

    @media screen and (max-width: 1500px) {
        .detail-down {
            .arrow-down{
                bottom: 0.7rem;
            }
            .data-down{
                margin: 2rem 2rem 0.5rem;
                height: calc(100% - 2.5rem);
                .good-grid{
                  
                    .good{
                        .detail{
                            margin: 0.5rem 1rem 0.5rem;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1200px) {
        .detail-down {
            .arrow-down{
                bottom: 0.5rem;
            }
            .data-down{
                margin: 3rem 2rem 3rem;
                height: calc(100% - 6rem);
                .good-grid{
                    grid-template-columns: repeat(4,23.5%); 
                    grid-auto-rows: 1fr;
                    grid-column-gap: 2%; 
                    grid-row-gap: 1.5rem;
                    .good{
                        .detail{
                            
                            .nameG{
                                padding: 0 0 0.5rem;
                                .name{
                                    font-size: var(--fs-search-name) ;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1000px) {
        .detail-down {
            .arrow-down{
                bottom: 0;
            }
            .data-down{
                margin: 3rem 2rem 2.5rem;
                height: calc(100% - 5.5rem);
                .good-grid{
                    grid-template-columns: repeat(3,31.33%); 
                    grid-auto-rows: 1fr;
                    grid-column-gap: 2%; 
                    grid-row-gap: 1.5rem;
                    margin: 0.5rem 1.5rem;
                    .good{
                        .detail{               
                            .nameG{
                                padding: 0 0 0.5rem;
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 850px) {
        /* inset:  0;
        height: 100%; */
        .detail-down {
            .arrow-down{
                bottom: 0;
            }
            .data-down{
                margin: 3rem 2rem 2.5rem;
                height: calc(100% - 5.5rem);
             
                .good-grid{
                    grid-template-columns: repeat(2,49%); 
                    grid-auto-rows: 1fr;
                    grid-gap: 2%; 
                    grid-row-gap: 1rem;
                    margin: 0.5rem 1rem;
                    .good{
                        .image{
                            width: 55%;
                            padding-top: 45%;
                        }
                        .detail{
                            .nameG{
                                padding: 0 0 0.5rem;
                            }
                            .price{
                                display: block;
                                .curency{
                                    display: flex;
                                    flex-direction: row;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    
    @media screen and (max-width: 500px) {
        .detail-down {
            top: 135vh;
            .arrow-down{
                bottom: 0;
            }
            .data-down{
                margin: 0.5rem 1rem 2.5rem;
                padding: 1rem 0 2rem;
                height: calc(100% - 6rem);
                ::-webkit-scrollbar-track {
                    display: none;
                }
                ::-webkit-scrollbar {
                    display: none;
                }
                ::-webkit-scrollbar-thumb {
                    display: none;
                }
                .good-grid{
                    grid-auto-rows: 1fr;
                    margin: 0.5rem 0;
                    .good{
                        .image{
                            padding-top: 50%;
                        }
                        .detail{
                            .nameG{
                                padding: 0 0 0.5rem;
                            }
                            
                            .curency{
                                font-size: 0.7rem;
                            }    
                        
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 400px) {
        .center-bar{
            .shop-slider{
                top: 77vh;
            }
        }
        .priceStyle{
            flex-wrap: wrap;
            justify-content: right;
        }
    }
    
`

class SearchDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            response: 'pending',
            sending: false,
            objectData: false,
            srch:'G_NAME'
        };
    }

    // initial data for search drawer
    componentDidMount () {
        this.getSearch(this.props.keyword);
    }

    // get if saerch keyword data has updated or nor
    getSnapshotBeforeUpdate(prevProps, prevState){
        if (prevProps.keyword !== this.props.keyword){
            return true;
        } else {
            return false;
        }
    }

    // if updated get data from server
    componentDidUpdate(prevProps, prevState, snapshot){
        if (snapshot){
            this.getSearch(this.props.keyword)
        }
    }

    // get server data for serched key word
    getSearch = (keyword) => {
        if(keyword.length > 1){
            let formData = new FormData();
            formData.append('G_NAME', keyword);
            this.setState({
                response: 'pending',
                sending: true,
                objectData: false,
            });
            PostData(process.env.REACT_APP_API + '/api/v1/exb/search',formData, this, this.SearchProccess);
        }
    }

    // proccess serch response data
    SearchProccess(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {
            obj.setState({
                response: 'success',
                objectData: response.Goods,
                sending: false,
            });
        } else if (response.status === 'error') {
            obj.setState({
                response: 'success',
                sending: false,
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending: false
            });
        }
    }

    // if click happen on goods close sheet and return scroll to normal
    onGoodClicked = () => {
        if(typeof this.props.clearSearch == 'function'){
            this.props.clearSearch();
        }
        document.getElementsByTagName("BODY")[0].style.overflow = 'auto';
    }

    // make ui grid for goods
    makeSearchedGrid = () => {
        if(!this.state.sending) {
            if(this.state.objectData){
                let goods = this.state.objectData.map((value, index) => {
                    return (
                        <Link to={{pathname: encodeURI('/good/' + value.Data.G_CODE+'/'+ value.Data.G_URL+'/')}} onClick={this.onGoodClicked} key={index}>
                        <div key={index} className="good">
                            <div className="image">
                                <img src={value.Data.G_IMAGE} alt={value.Data.G_NAME}/>
                            </div>
                            <div className="detail">
                                <div className="nameG">
                                    <span className='name'>{value.Data.G_NAME}</span>
                                    <span className='brand'>برند:  {value.Data.G_BR_NAME} </span>
                                    <span className='shop'>تعداد فروشنده: {value.shop_count}</span>
                                    <Stars star={value.Ave}/>
                                </div>
                                <Price min={value.Min} max={value.Max}/>
                            </div>
                        </div>
                        </Link>
                    )
                })
                return(
                    <div className="good-grid">
                        {goods}
                    </div>
                )
            } else {
                return (
                    <div className="loading-container">
                        نیافتم!! دوباره امتحان کن
                    </div>
                )
            }
        } else {
            return (
                <div className="loading-container">
                   <Loading/>
                </div>
            )
        }
    }
    
    // main structure for rendering search ui
    render() {
        let classesDown = 'detail-down';
        if (this.props.open === true){
            document.getElementsByTagName("BODY")[0].style.overflow = 'hidden';
        
            classesDown = 'detail-down active-down';
        } else if(this.props.open === false){
            document.getElementsByTagName("BODY")[0].style.overflow = 'auto';
            classesDown = 'detail-down deactive-down';
        }
        return (
            <Styles>
                <div className={classesDown} style={{height :( this.state.objectData.length ? '' : '0') , display:( this.state.objectData.length ? '' : 'none')}}>
                    <div className="data-down no-click-details1">
                        {this.makeSearchedGrid()}
                    </div>
                </div>
            </Styles>
        )
    }
}

export default SearchDrawer;
